import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';

import ReactTooltip from 'react-tooltip';

import {
  focusAfterTimeout
} from '../../util';
import { getIcon } from '../../util/icons';

class TodoList extends Component {

  state = {
    showCompleted: false,
    addingNewItem: false,
    newItemText: '',
    savingItem: false,
  }

  renderItem(item, index){

    const { secondaryAction } = this.props;
    const {text, completed, completedOn} = item;


    let secondaryActionIsDone = false;

    if(secondaryAction && secondaryAction.isDone(item)){
      secondaryActionIsDone = true;
    }

    if(!this.state.showCompleted && completed){
      return null;
    }

    return (
      <div key={index} className={`item ${completed ? ' done' : ''} ${secondaryActionIsDone ? secondaryAction.doneClass : ''} ${secondaryAction ? 'has-secondary' : ''}`}>
        <div className="item-text fs-block">{text}</div>

          {/*<div className="item-check">{getIcon(`check-${completed ? 'fill' : 'empty'}`)}</div>*/}
          {completed && completedOn &&
            <div className="item-completed-on">{getIcon('check')} on {moment(completedOn).format('MM/DD/YY')}
              <div className="item-actions">
                <span className="action" onClick={() => { this.uncompleteItem(item); } }>mark incomplete</span>
                <span className="action" onClick={() => { this.deleteItem(item); } }>delete</span>
              </div>
            </div>
          }
          {!completed &&
            <React.Fragment>
              <div
                data-tip="Mark Completed"
                data-for={`complete-action-tooltip-for-item-${index}`}
                onClick={() => { this.completeItem(item); }}
                className="item-check">{getIcon('check')}</div>
              <ReactTooltip id={`complete-action-tooltip-for-item-${index}`} effect="solid" place="top" />
            </React.Fragment>
          }
          {!completed && secondaryAction && (secondaryAction.showIfDone || !secondaryActionIsDone) &&
            <React.Fragment>
              <div
                data-tip={secondaryActionIsDone ? secondaryAction.doneTooltip : secondaryAction.tooltip}
                data-for={`secondary-action-tooltip-for-item-${index}`}
                onClick={() => { secondaryAction.action(item); }}
                className={`item-secondary ${secondaryActionIsDone ? 'done' : ''}`}>{getIcon(secondaryAction.icon)}</div>
              <ReactTooltip id={`secondary-action-tooltip-for-item-${index}`} effect="solid" place="top" />
            </React.Fragment>
          }
      </div>
    );
  }

  beginAddingNewItem(){
    this.setState({
      addingNewItem: true,
      newItemText: ''
    });
    focusAfterTimeout(this, 'newItemInput');
  }

  addNewItem(){
    this.props.addItem(this.state.newItemText);
    this.setState({
      newItemText: '',
      addingNewItem: false,
    });
  }

  completeItem(item){
    this.props.completeItem(item);
  }
  uncompleteItem(item){
    this.props.uncompleteItem(item);
  }
  deleteItem(item){
    this.props.deleteItem(item);
  }

  handleKeyUp(props){
    //handle for escKey returnKey

    // console.log(props.key);

    if(props.key === 'Escape'){
      this.setState({
        addingNewItem: false,
        newItemText: '',
      });
    }
    if(props.key === 'Enter' && this.state.newItemText !== ''){
      this.addNewItem();
    }
  }

  renderAddNew(){
    const { newItemLabel } = this.props;
    const { newItemText, addingNewItem, savingItem } = this.state;

    if(!addingNewItem){
      return (
        <div
          onClick={this.beginAddingNewItem.bind(this)}
          className="new-item">+ {newItemLabel || 'New item'}</div>
      );
    }
    else{
      return (
        <div className="new-item-input">
          <input
            ref={input => { this.newItemInput = input; }}
            onBlur={() => { if(!newItemText){ this.setState({ addingNewItem: false }) } }}
            placeholder={newItemLabel || 'New item'}
            className="new-item-input fs-block"
            value={newItemText}
            onKeyUp={this.handleKeyUp.bind(this)}
            onChange={(e) => { this.setState({ newItemText: e.target.value }); }}
          />
          <button
            onClick={this.addNewItem.bind(this)}
            className="button blue-button button-sm">Add</button>
        </div>
      );
    }
  }

  renderCompletedToggle(){

    const { showCompleted } = this.state;

    const { items } = this.props;

    //if no completed items
    const completedItems = _.filter(items, { completed: true });
    if(!completedItems[0]){
      return null;
    }

    return (
      <div
        onClick={() => { this.setState({ showCompleted: !showCompleted }); }}
        className="show-completed-toggle">
        {showCompleted ? 'hide completed items' : 'show completed items (' + completedItems.length + ')'}
      </div>
    );
  }

  render(){

    const { items, addNew, className } = this.props;

    const sortedItems = _.sortBy(items, (item, index) => {
      // console.log('sorting: ', item);
      if(item.completed){
        // console.log('sorting by: ', item.completedOn);
        return item.completedOn;
      }
      else{
        return _.indexOf(item, items);
      }
    });

    return (
      <div className={`todo-list ${className}`}>
        {this.renderCompletedToggle()}
        <div className="items">
          {_.map(sortedItems, this.renderItem.bind(this))}
        </div>
        {this.renderAddNew()}
      </div>
    );
  }
}

export default TodoList;



// WEBPACK FOOTER //
// ./src/components/shared/todoList.js